import { InjectionToken } from '@angular/core';
import { NotificationGridSetting } from './model/grid/notification-grid-setting';

export const NOTIFICATION_GRID_SETTINGS = new InjectionToken<Map<string, NotificationGridSetting>>(
  'NOTIFICATION_GRID_SETTINGS'
);
